/**
 * Errore generico della libreria con supporto all'exception nesting.
 *
 * In pratica conserva al suo interno un riferimento all'errore che lo ha generato (se esiste) per tracciabilità
 * @author Riccardo Di Dato
 */
export class ShatsuGenericError extends Error {
    parent;
    /**
     * Costruisce l'errore, è possibile passare alla classe un *errore genitore / innestato*
     * @param message Messaggio dell'errore
     * @param parent Errore genitore o `null`
     */
    constructor(message, parent = null) {
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ShatsuGenericError.prototype);
        this.parent = parent;
    }
    /**
     * Restituisce l'errore che ha causato questo errore, null se non esiste
     * @returns Errore genitore
     */
    getParent() {
        return this.parent;
    }
}
